export default {
    contents (state) {
      return state.contents
    },

    selectedContent (state) {
        return state.selectedContent
    },

    getContent: state => (eventId) => {
      return state.content.find(event => event.eventId === eventId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/getters.js